import colors from '../../colors';
import sizes from '../../sizes';
import lightBase from './base';

const lightCompact = {
    ...lightBase,
    current: {
        default: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: lightBase.current.text
        },
        hover: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: lightBase.current.text
        },
        focus: {
            container: {
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: lightBase.current.text
        }
    },
    inactive: {
        default: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.transparent,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: lightBase.inactive.text
        },
        hover: {
            container: {
                borderBottomWidth: 2,
                borderBottomColor: colors.coolGray500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            },
            text: lightBase.inactive.hoverText
        },
        focus: {
            container: {
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28,
                // Web-only: double ring shadow (will be in webOnlyStyles)
                boxShadow: `0px 0px 0px 3px ${colors.white}, 0px 0px 0px 5px ${colors.green500}`
            },
            text: lightBase.inactive.focusText
        }
    },
    disabled: {
        container: {
            paddingBottom: 8,
            paddingTop: 0,
            paddingLeft: 4,
            paddingRight: 4,
            height: 28
        },
        text: lightBase.disabled.text
    },
    container: {
        borderBottomWidth: 1,
        borderBottomColor: colors.coolGray200,
        backgroundColor: colors.white,
        paddingTop: sizes.fixedSpacing.md,
        paddingLeft: sizes.fixedSpacing['3xl'],
        emptySpaceHeight: sizes.fixedSpacing['4xl'],
        marginBottom: sizes.fixedSpacing.lg,
        boxShadow: '-5px 5px 10px 0 rgba(24, 29, 39, 0.08)'
    },
    panel: {
        padding: `0 ${sizes.fixedSpacing['md']}px`
    }
};

export default lightCompact;
